<template>
    <div class="font-prompt totop-div">
        <b-modal :id="modalError.id"
                modal-class="modal-alert"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc>
             <div class="modal-base">
                <div class="modal-base-head">
                    <!-- <div class="modal-base-close" @click="clickCloseAddressModal()"></div> -->
                    <p>{{modalError.title}}</p>
                </div>
                <div class="modal-base-body text-center">
                    <p v-html="modalError.message"></p>
                </div>
                <div class="modal-base-footer text-center">
                    <button class="btn-black btn-close" @click="clickSubmit()">{{modalError.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';

/**
 * @property {Vue} busModal
 *
 * @method showModal
 * @method hideModal
 */
export default {
    name: "ModalBoutiqueID",
    props: {
        busModal: Object,
        view: String,
    },
    components: {

    },
    data: function() {
        return {
            type: "campaign", // ticket, campaign
            paramStr: "",

            modalError: {
                id: 'modal-error-boutiqueid-',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
        };
    },
    created: function() {

        this.modalError.id += this.view;
    },
    mounted: function() {
        this.busModal.$on('showModal', this.showModal);
        this.busModal.$on('hideModal', this.hideModal);
        setTimeout(() => {
            window.scrollTo(0,0);
        }, 500);

    },
    methods: {
        showModal: function(config) {
            this.modalError.title = config.title;
            this.modalError.message = config.message;
            this.modalError.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalError.tag = config.tag;

            this.$bvModal.show(this.modalError.id);

            this.$nextTick(() => {
			    window.scrollTo(0, 0);
		    });
        },
        clickSubmit: function() {
            this.$emit('modalBoutiqueIDHidden', { tag: this.modalError.tag });
        },

        hideModal: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
@import "@/style/base/component/modal/modal.scss";
.btn-black {
    color: #fff;
    background-color: black;
    border-color: black;
    width: 100%;
    margin: auto;
}

</style>
